module.exports = __webpack_public_path__ + "img/payment-mono.08a11582.svg";